import { JSX } from "react";
import FeatureCarousel from "../components/FeatureCarousel/FeatureCarousel";
import RewardSection from "../components/RewardsSection/RewardSection";
import Tools from "../components/Tools/Tools";
import ServiceSection from "../components/ServiceSection/ServiceSection";
import DisclaimerStrip from "../components/DisclaimerStrip/DisclaimerStrip";
import IpoTitle from "../components/IpoTitleWithDescription/IpoTitle";
import EasyAccess from "../components/EasyAccess/EasyAccess";
import MarketTodayServer from "../components/MarketToday/MarketTodayServer";
import SectorSection from "../components/SectorSection/SectorSection";
import CLPSeparator from "../components/CLPSeparator/CLPSeparator";
import { TopCategories } from "../components/ClpStockCards/TopCategories";
import { MostBroughtStocks } from "../components/ClpStockCards/MostBroughtStocks";
import { PayLaterMtf } from "../components/PayLaterMtfs/PaylaterMtf";
import { RecentlyViewed } from "../components/RecentlyViewed/RecentlyViewed";
import IpoList from "../components/IpoList/IpoList";
import { TradingSectionTabs } from "../components/TradingSection/TradingSectionTabs";
import UpcomingIpoTabs from "../components/UpcomingIpo/UpcomingIpoTabs";
import Banner from "../components/Banner/Banner";
import DescriptionWithColumns from "../components/DescriptionWithColumns/DescriptionWithColumns";
import PoweredBy from "../components/PoweredBy/PoweredBy";
import VideoCarousel from "../components/VideoCarousel/VideoCarousel";
import Portfolio from "../components/Portfolio/Portfolio";
import PortfolioContainer from "../components/Portfolio/PortfolioContainer";
import Disclaimer from "../components/Disclaimer/Disclaimer";
import ADPSeparator from "../components/ADPSeparator/ADPSeparator";
import PortfolioHeader from "../components/Portfolio/PortfolioHeader";
import FAQ from "../components/FAQ/FAQ";
import RelatedLinks from "../components/RelatedLinks/RelatedLinks";
import HideOnLogin from "../components/HideOnLogin/HideOnLogin";
import Breadcrumbs from "../components/Breadcrumbs/Breadcrumbs";
import { isOpenInApp, stringToBoolean } from "@repo/shared-utils/pwa-utils";
import News from "../components/News/News";
import TrendingNewsAEM from "../components/News/components/TrendingNewsAEM";
import IpoServer from "../components/Ipo/IpoServer";
import CurrentIPOServer from "../components/CurrentIPO/CurrentIPOServer";
import MarketInsightsHeading from "../components/MarketInsigtsHeading/MarketInsightsHeading";
import { MarketIndicesDashboard } from "../components/MarketIndicesDashboard";
import LatestFinancialResult from "../components/LatestFinancialResult/LatestFinancialResult";
import LatestFinancialResultMain from "../components/LatestFinancialResult/LatestFinancialResultMain";
import FiiAndDiiTradingActivityServer from "../components/FiiAndDiiTradingActivity/FiiAndDiiTradingActivityServer";
import PreMarketInsights from "../components/PreMarketInsights/PreMarketInsights";
import StockListingTableAEM from "../components/StockListingTable/StockListingTableAEM";
import TrendingStocksPlpClient from "./TrendingStocksPlp/TrendingStocksPlpClient";
import TrendingStocksInfoBanner from "./TrendingStocksPlp/components/TrendingStocksInfoBanner";
import TrendingStocksCarousel from "./TrendingStocksPlp/TrendingStocksCarousel";
import ClosedIPOServer from "../components/ClosedIPO/ClosedIPOServer";
import UpcomingIpo from "../components/UpcomingIpo/upcomingIpo";
import ClpHeader from "../components/ClpHeader/ClpHeader";
import StockTable from "./StockListingPage/components/StockTable";
import StockListWithTabs from "./GlobalIndices/StockListWithTabs";
import { BudgetETFs } from "../components/BudgetFriendlyETFs/BudgetETFs";
import BudgetEtfMain from "../components/BudgetFriendlyETFs/BudgetEtfmain";

interface SelectComponentProps {
  data: any;
  index: number;
  isMobileApp: boolean;
  version?: string;
  componentName: string;
}

export const selectComponent = (props: SelectComponentProps) => {
  const { data, index, componentName, isMobileApp } = props;

  const componentLookup: Record<string, () => JSX.Element | null> = {
    featureCarousel: () => (
      <FeatureCarousel key={"featureCarousel-" + index} content={data} />
    ),
    ipoTitle: () => (
      <IpoTitle
        key={"ipoTitle-" + index}
        ipoTitle={data?.ipoTitle}
        ipoDescription={data?.ipoDescription}
        defaultVariant={data?.defaultVariant}
        customClass={data?.customClass}
        headingLevel={data?.headingLevel}
      />
    ),
    rewardSection: () => (
      <RewardSection key={"rewardSection-" + index} content={data} />
    ),
    payLaterViaMtfs: () => <PayLaterMtf key={"PayLaterMtfs-" +index} content={data}/>,

    tools: () => <Tools key={"tools-" + index} content={data} />,
    serviceSection: () => (
      <ServiceSection key={"ServiceSection-" + index} content={data} />
    ),
    sectorSection: () => (
      <SectorSection key={"sectorSection-" + index} content={data} />
    ),
    disclaimerStrip: () => (
      <DisclaimerStrip
        key={"disclaimerStrip-" + index}
        disclaimer={data?.disclaimer}
        disclaimerId={data?.disclaimerId}
        customClass={data?.customClass}
      />
    ),
    tradingSectionTabs: () => (
      <TradingSectionTabs content={props.data} key={props.componentName} />
    ),
    upcomingIpoTabs: () => (
      <UpcomingIpoTabs content={props.data} key={props.componentName} />
    ),
    easyAccessComponent: () => (
      <EasyAccess content={props.data} key={props.componentName} />
    ),
    topCategoriesTabs: () => {
      return <TopCategories content={data} key={props.componentName} />;
    },
    mostBoughtStocks: () => {
      return <MostBroughtStocks content={data} key={props.componentName} />;
    },
    payLaterMtf: () => {
      return <PayLaterMtf content={data} key={props.componentName} />;
    },
    recentlyViewdStocks: () => {
      return (
        <RecentlyViewed
          content={data}
          isMobileApp={props.isMobileApp}
          key={props.componentName}
        />
      );
    },
    marketToday: () => (
      <MarketTodayServer key={"marketToday-" + index} content={data} />
    ),
    clpSeparator: () =>
      stringToBoolean(data?.hideOnLogin ?? "false") ? (
        <HideOnLogin key={"clpSeparator-" + index}>
          <CLPSeparator key={"clpSeparator-" + index} />
        </HideOnLogin>
      ) : (
        <CLPSeparator key={"clpSeparator-" + index} />
      ),
    ipoList: () => (
      <IpoList
        key={"ipoList-" + data.componentLink}
        componentLink={data.componentLink}
        headingLevel={data?.headingLevel}
        ipoTitle={data.ipoTitle}
        mainboardTitle={data.mainboardTitle}
        smeTitle={data.smeTitle}
        viewAllText={data.viewAllText}
        biddingPeriodText={data.biddingPeriodText}
        minimumInvestmentText={data.minimumInvestmentText}
        bidPriceText={data.bidPriceText}
        listingDateText={data.listingDateText}
        listingGainText={data.listingGainText}
        pageType={data.pageType}
        showMoreCtaText={data.showMoreCtaText}
        paginationLimit={data.paginationLimit}
        ipoType={data.ipoType}
        redirectToPdpBaseUrl={data.redirectToPdpBaseUrl}
        apiErrorDesc={data.apiErrorDesc}
        fetchApiDataErrorDesc={data.fetchApiDataErrorDesc}
        viewAllRedirectUrl={data.viewAllRedirectUrl}
        viewAllOpenNewTab={data.viewAllOpenNewTab}
        openInNewTab={data.openInNewTab}
        addSeperatorComponent={data.addSeperatorComponent}
        tbaText={data.tbaText}
        signInText={data.signInText}
        customClass={data.customClass}
      />
    ),
    closedIpoList: () => (
      <ClosedIPOServer key={`closedIpoList-${index}`} {...data} />
    ),
    bannerizationCarousel: () => (
      <Banner
        key={"bannerizationCarousel-" + index}
        bannerizationcarousel={data}
      />
    ),
    descriptionWithColumns: () => (
      <DescriptionWithColumns
        key={"descriptionWithColumns-" + index}
        id={data.id}
        heading={data.heading}
        informationText={data.informationText}
        description={data.description}
        isTwoColumn={data.isTwoColumn}
        hideOnLoggedIn={data.hideOnLoggedIn}
        customClass={data.customClass}
        showOnApp={data.showOnApp}
      />
    ),
    mediaWithText: () => (
      <PoweredBy key={"mediawithtext-" + index} content={data} />
    ),
    MediawithTextComponent: () => (
      <PoweredBy key={"mediawithtextcomponent-" + index} content={data} />
    ),
    videoCarousel: () => (
      <VideoCarousel key={"videocarousel-" + index} content={data} />
    ),
    portfolio: () => {
      return <Portfolio content={data} key={props.componentName} />;
    },
    portfolioDashboard: () => {
      return <PortfolioContainer cmpData={data} key={props.componentName} />;
    },
    portfolioHeaderComp: () => {
      return <PortfolioHeader content={data} key={props.componentName} />;
    },
    dynamicfaq: () => <FAQ key={"dynamicfaq-" + index} content={data} />,
    breadcrumb: () =>
      stringToBoolean(data?.hideOnLogin ?? "true") ? (
        <HideOnLogin key={"breadcrumb-" + index}>
          <Breadcrumbs content={data} />
        </HideOnLogin>
      ) : (
        <Breadcrumbs content={data} key={"breadcrumb-" + index} />
      ),
    currentIpoList: () => (
      <CurrentIPOServer key={`currentIpoList-${index}`} {...data} />
    ),
    disclaimer: () => <Disclaimer key={"disclaimer-" + index} content={data} />,
    relatedLinks: () => {
      const { showOnApp, showOnWeb } = data;
      const shouldShow =
        (isOpenInApp() && showOnApp === "true") ||
        (!isOpenInApp() && showOnWeb === "true");

      return shouldShow ? (
        stringToBoolean(data?.hideOnLogin ?? "true") ? (
          <HideOnLogin key={"relatedLinks-" + index}>
            <RelatedLinks content={data} />
          </HideOnLogin>
        ) : (
          <RelatedLinks content={data} key={"relatedLinks-" + index} />
        )
      ) : null;
    },
    adpseparator: () => {
      return <ADPSeparator content={data} key={props.componentName} />;
    },
    adpSeparator: () => <ADPSeparator content={data} key={`adp-${index}`} />,
    news: () => <News key={"news-" + index} content={data} />,

    marketInsightsHeading: () => (
      <MarketInsightsHeading
        key={"marketInsightsHeading-" + index}
        content={data}
      />
    ),
    allIpoList: () => (
      <IpoServer key={`currentIpoList-${index}`} {...data} />
    ),

    indicesInsights: () => (
      <MarketIndicesDashboard
        key={`indicesInsights-${index}`}
        isMobileApp={isMobileApp}
        config={{
          heading: data?.heading,
          componentPosition: data?.componentPostion,
          indexValueDisplay: {
            pcrLabelPrefix: data?.indexValueDisplay?.pcrLabelPrefix,
          },
          openInterest: {
            callLabel: data?.openInterest?.callLabel,
            putLabel: data?.openInterest?.putLabel,
            errorMessage: data?.openInterest?.errorMessage,
            fallbackValue: data?.openInterest?.fallbackValue,
          },
          daysRange: {
            label: data?.daysRange?.label,
          },
          actions: {
            optionChainCta: data?.actions?.optionChainCta,
            chartsCta: data?.actions?.chartsCta,
            chartsWebViewTitle: data?.actions?.chartsWebViewTitle,
            optionChainWebViewTitle: data?.actions?.optionChainWebViewTitle,
            tradingMallBaseUrl: data?.actions?.tradingMallBaseUrl,
            chartsScreen: data?.actions?.chartsScreen,
            optionChainScreen: data?.actions?.optionChainScreen,
          },
        }}
      />
    ),

    latestFinancialsResult: () => (
      <LatestFinancialResult
        key={`latestFinancialsResult-${index}`}
        heading={data?.heading}
        description={data?.description}
        viewAll={data?.viewAll}
        redirectUrl={data?.redirectUrl}
        componentPosition={data?.componentPostion}
        openInNewTab={data?.openInNewTab}
        isMobileApp={isMobileApp}
      />
    ),

    latestFinancialResultMain: () => (
      <LatestFinancialResultMain
        key={`latestFinancialResultMain-${index}`}
        mainHeading={data?.mainHeading}
        heading={data?.heading}
        description={data?.description}
        componentPosition={data?.componentPostion}
      />
    ),

    fiiAndDiiTradingActivity: () => (
      <FiiAndDiiTradingActivityServer
        key={`fiiAndDiiTradingActivity-${index}`}
        heading={data?.heading}
        cashLabel={data?.cashLabel}
        futuresLabel={data?.futuresLabel}
        componentPosition={data?.componentPostion}
      />
    ),

    preMarketInsights: () => (
      <PreMarketInsights key={`preMarketInsights-${index}`} content={data} />
    ),

    trendingNews: () => (
      <TrendingNewsAEM
        key={"trendingNews-" + index}
        title={data?.componentTitle}
        subtitle={data?.subTitle}
        maxArticles={data?.maxArticles}
        categoryTags={data?.categoryTags}
        showViewAll={data?.showViewAll}
        viewAllText={data?.viewAllText}
        viewAllLink={data?.viewAllLink}
        errorTitle={data?.errorTitle}
        errorDescription={data?.errorDescription}
        errorRetryButtonText={data?.errorRetryButtonText}
        errorImageSrc={data?.errorImageSrc}
        errorImageAlt={data?.errorImageAlt}
        emptyStateTitle={data?.emptyStateTitle}
        emptyStateDescription={data?.emptyStateDescription}
        emptyStateImage={data?.emptyStateImage}
        scrollLeftAriaLabel={data?.scrollLeftAriaLabel}
        scrollRightAriaLabel={data?.scrollRightAriaLabel}
        timestampLabels={data?.timestampLabels}
        images={data?.images}
        isEmpty={data?.isEmpty}
      />
    ),
    stockListingTable: () => (
      <StockListingTableAEM key={`stockListingTable-${index}`} {...data} />
    ),
    globalIndices: () => (
      <StockListWithTabs
        key={`globalIndices-${index}`}
        data={data}
        initialData={data?.initialData}
        initialTabData={data?.initialTabData}
      />
    ),
    globalIndicesStockTable: () => (
      <StockTable
        key={`globalIndicesStockTable-${index}`}
        data={data?.data}
        entityType={data?.entityType}
        isLoading={Boolean(data?.isLoading)}
        isListUpdating={Boolean(data?.isListUpdating)}
        showBookmark={data?.showBookmark ?? false}
        isGlobalIndicesPage={data?.isGlobalIndicesPage ?? true}
        uiLabels={data?.uiLabels}
        tableLabels={data?.tableLabels}
      />
    ),
    trendingStock: () => (
      <TrendingStocksPlpClient key={`trendingNews-${index}`} {...data} />
    ),
    trendingStocksInfoBanner: () => (
      <TrendingStocksInfoBanner
        key={`trendingStocksInfoBanner-${index}`}
        text={data?.text ?? data?.infoBannerText}
        ctaText={data?.ctaText ?? data?.infoBannerCtaText}
        ctaUrl={data?.ctaUrl ?? data?.infoBannerCtaUrl}
      />
    ),
    trendingStockCarousel: () => (
      <TrendingStocksCarousel
        key={`trendingStockCarousel-${index}`}
        content={data}
      />
    ),
    upcomingIpo: () => {
      return <UpcomingIpo key={"upcomingIpo-" + index} {...data} />;
    },
    default:() => {
      return null
    },
    clpHeader: () => (
      <ClpHeader
        key={`clpHeader-${index}`}
        title={data?.title}
        description={data?.description}
        customClass={data?.customClass}
        descriptionCustomClass={data?.descriptionCustomClass}
      />
    ),
    budgetFriendlyEtfs: () => (
      <BudgetETFs content={data} key={props.componentName} />
    ),
    budgetFriendlyEtfsMain: () => (
      <BudgetEtfMain
        key={`budgetFriendlyEtfsMain-${index}`}
        mainHeading={data?.mainHeading}
        heading={data?.heading}
        description={data?.description}
        defaultSort={data?.defaultSort}
        componentPosition={data?.componentPostion}
        loggedInRedirectionUrl={data?.loggedInRedirectionUrl}
        screen={data?.screen}
        webViewTitle={data?.webViewTitle}
        stockNotFoundText={data?.stockNotFoundText}
        stockNotFoundImgUrl={data?.stockNotFoundImgUrl}
        errorTitle={data?.errorTitle}
        errorDescription={data?.errorDescription}
        errorRetryButtonText={data?.errorRetryButtonText}
        errorImageAlt={data?.errorImageAlt}
        errorImageSrc={data?.imageSrc}
        showMoreText={data?.showMoreText}
        showLessText={data?.showLessText}
        companyName={data?.companyName}
      />
    ),
  };

  const formattedComponentName = componentName.replace(/[^A-Za-z]/g, "");
  const componentFn = componentLookup[formattedComponentName];
  return componentFn;
};